const AbstractVerifoneConstantList = require('./AbstractVerifoneConstantList');

class VerifoneStatusList extends AbstractVerifoneConstantList {
    /**
     * @param {string} name
     *
     * @return {{id: number, message: string, customerFacingMessage?:string, icon?:string, actions?:string[]}|undefined}
     */
    findByName(name) {
        return super.findByName(name);
    }

    /**
     * @param {number} id
     *
     * @return {string}
     */
    findNameById(id) {
        return super.findNameById(id);
    }
}

module.exports = VerifoneStatusList;
